<script setup lang="ts">
import { HeartIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  class: {
    type: String,
    default: "text-white h-6 w-6",
  },
});

defineEmits(["update:modelValue"]);
</script>
<template>
  <label>
    <input
      type="checkbox"
      class="hidden"
      :value="modelValue"
      @input="() => $emit('update:modelValue', !modelValue)"
    />
    <HeartIcon
      :class="[
        props.class,
        modelValue ? ' fill-red-500 text-white ' : '',
        'heroicon-sw-1',
      ]"
    />
  </label>
</template>
